import React, { FunctionComponent } from 'react';
import cls from '../utils/classnames';
import { TOOLTIP, TOOLTIP_CONTENT, TOOLTIP_TITLE } from '../utils/classes';
import './_styles.scss';

export type TooltipVariant = 'error' | 'success' | 'default';

export interface ITooltipProps {
    title?: string;
    variant?: TooltipVariant;
    passWordClass?: string;
}

export const Tooltip: FunctionComponent<ITooltipProps> = props => {
    const { title, variant = 'default', children, passWordClass } = props;
    const className = cls(TOOLTIP_CONTENT, passWordClass, {
        [`${TOOLTIP}-${variant}`]: Boolean(variant)
    });
    return (
        <div className={TOOLTIP}>
            <span className={cls(className)}>
                {title && <h4 className={cls([`${TOOLTIP_TITLE}-${variant}`])}>{title}</h4>}
                {children}
            </span>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/packages/components/lib/Tooltip/index.tsx